import React, {useContext} from 'react';
import {SectionsContext} from "../contexts/SectionsProvider";
import {MortgageContext} from "../contexts/MortgageProvider";
import Menu from "../ui/outlet-views/Menu";
import {you, capitaliseFirst} from "../../common/section-questions/applicant/__strings";

function ApplyAppMenu(props) {
    const mortgageContext = useContext(MortgageContext)
    const sectionsContext = useContext(SectionsContext)
    const items = sectionsContext.sections.apply.filter(i=>i.applicant===props.applicant)
    const y = you(props.applicant === 1 ? false : mortgageContext.mortgage.applicant2?.firstName ? mortgageContext.mortgage.applicant2.firstName:'the other applicant')

    return <Menu
        title={capitaliseFirst(y.your) + ' details'}
        back={'/apply'}
        progress={0}
        items={items}
    >
    </Menu>
}
export default ApplyAppMenu;